function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.7986,
  cy: 5.82912,
  rx: 3.5,
  ry: 3.36,
  stroke: "#6C48FB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2012 16.384C23.2901 16.3863 22.4278 15.9889 21.8599 15.305C19.9064 12.947 16.9369 11.5763 13.7986 11.584C9.38213 11.5882 5.80299 15.0242 5.79858 19.264C5.79858 20.3244 6.69401 21.184 7.79858 21.184C8.90315 21.184 9.79858 20.3244 9.79858 19.264C9.80427 17.5162 11.0364 15.9916 12.7986 15.552V16.192C12.8022 20.3273 11.527 24.3705 9.13458 27.8093C8.52192 28.693 8.77144 29.8861 9.69192 30.4743C10.6124 31.0624 11.8552 30.8229 12.4679 29.9392C13.733 28.1164 14.7413 26.1408 15.4666 24.064C17.5511 25.3264 19.1187 27.2399 19.9052 29.4823C20.1122 30.1556 20.6855 30.6667 21.4002 30.8153C22.1149 30.9638 22.8571 30.7261 23.3357 30.1953C23.8142 29.6645 23.9529 28.9253 23.6972 28.2675C22.4752 24.7739 19.8795 21.8769 16.4639 20.1946C16.6888 18.8713 16.8017 17.5328 16.8012 16.192V16.1536C17.5495 16.5409 18.2085 17.0695 18.7386 17.7075C20.0637 19.3058 22.0774 20.2347 24.2052 20.2291C25.3098 20.2291 26.2052 19.3695 26.2052 18.3091C26.2052 17.2488 25.3098 16.3891 24.2052 16.3891L24.2012 16.384Z",
  stroke: "#6C48FB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.98509350da2ac55b31f3ae00d79ca064.svg";
export { ForwardRef as ReactComponent };